import { render, staticRenderFns } from "./TurnoForm.vue?vue&type=template&id=23380d1d"
import script from "./TurnoForm.vue?vue&type=script&lang=js"
export * from "./TurnoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports